import React from "react";
import "./SocialLoginButton.css";

const SocialLoginButton = ({ disabled, label, href, icon }) => {
    return (
        <button
            className="social-login-button"
            onClick={() => window.location.href = href}
            disabled={disabled}
        >
            <img src={icon} alt={`${label} icon`} className="social-icon" />
            <span className="login-text">{label}</span>
        </button>
    );
};

export default SocialLoginButton;
